import styled, { DefaultTheme, ThemeProps } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/core';
import {
    MatrixHeaderWrapperElement,
    matrixFactory,
    matrixAsideFactory,
    matrixHeaderFactory,
    MatrixContentWrapperElement,
    matrixVectorFactory,
    MatrixVectorWrapperElement,
    MatrixAsideWrapperElement,
} from '../../../../../components/commander-ui/Matrix';
import { BlockSetupMatrixCornerCell } from './BlockSetupMatricCornerCell';

export const getGreyBorderStyle = ({ theme }: ThemeProps<DefaultTheme>) =>
    `1px solid ${getToken('borderStaticPrimary')({ theme })}`;

const CornerCell = styled(BlockSetupMatrixCornerCell)`
    border-bottom: ${getGreyBorderStyle};
    border-left: ${getGreyBorderStyle};
    border-top: ${getGreyBorderStyle};
    display: flex;
    align-items: center;
    padding: ${getSpacingToken('200')}px;
`;

const MatrixHeaderWrapper = styled(MatrixHeaderWrapperElement)`
    border-bottom: ${getGreyBorderStyle};
    border-top: ${getGreyBorderStyle};
`;

const MatrixAsideWrapper = styled(MatrixAsideWrapperElement)`
    border-left: ${getGreyBorderStyle};
`;

export const BlockSetupMatrixElement = matrixFactory({
    MatrixAside: matrixAsideFactory({ CornerCell, MatrixAsideWrapper }),
    MatrixHeader: matrixHeaderFactory({ MatrixHeaderWrapper }),
    MatrixContentWrapper: styled(MatrixContentWrapperElement)`
        border-left: ${getGreyBorderStyle};
    `,
});

export const BlockSetupMatrixVectorElement = matrixVectorFactory({
    MatrixVectorWrapper: styled(MatrixVectorWrapperElement)`
        &:hover {
            background-color: ${getToken('backgroundStaticSunken')};
        }
    `,
});
